import logo from '../images/logo.png';
import styled from 'styled-components';

const Title = styled.h1`
    font-size: inherit;
    margin: 0 6px 0 0;
    display: inline-block;
    vertical-align: middle;
    font-weight: normal;
    font-size: 36px;
`

const Image = styled.img`
    width: 36px;
    vertical-align: middle;
`

const Anchur = styled.a`
    text-decoration: unset;
    color: #007fe4;
    font-size: 16px;
`

export const Logo = () => <>
    <Title>damascena</Title>
    <Image src={logo} alt="logo" />
    <br />
    <Anchur href='https://docs.google.com/forms/d/1ovnZTe0DKDbGf12tQ1_dHN4uwCa4wTWpfkwXQ0ADE88/edit'>精油についてお聞かせ下さい（アンケート）</Anchur> <br />
    <Anchur href='https://www.amazon.co.jp/vdp/230aac5b85ce454088b26378e9ccad66?product=B09PVL32WZ&ref=cm_sw_tw_r_ib_dt_XNbcSHxHubFmh'>精油の使い方を動画で見る</Anchur>
</>
